import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Input, Button, Text, HStack } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useMICUTheme } from '../lib/micu/MICUThemeProvider';
import { createCase } from '../lib/micu/micuDatabase';

function formatDefaultName() {
  const now = new Date();
  const mm = (now.getMonth() + 1).toString().padStart(2, '0');
  const dd = now.getDate().toString().padStart(2, '0');
  const yyyy = now.getFullYear();
  const hh = now.getHours().toString().padStart(2, '0');
  const min = now.getMinutes().toString().padStart(2, '0');
  return `${mm}/${dd}/${yyyy} ${hh}:${min}`;
}

const MICUNewCase = () => {
  const navigate = useNavigate();
  const { isDark } = useMICUTheme();
  const inputRef = useRef();
  const [name, setName] = useState(formatDefaultName);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    // Auto-select the input text so typing overwrites the default
    if (inputRef.current) {
      inputRef.current.select();
    }
  }, []);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setCreating(true);
    const id = await createCase(name.trim());
    navigate(`/micu-mobile/case/${id}/patient`);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleCreate();
  };

  return (
    <Box p={4}>
      <HStack spacing={2} mb={6}>
        <Button
          variant="micuGhost"
          size="sm"
          leftIcon={<ArrowBackIcon />}
          onClick={() => navigate('/micu-mobile')}
        >
          Back
        </Button>
      </HStack>

      <Text fontSize="xl" fontWeight="bold" color="micu.text" mb={4}>New Case</Text>

      <Text fontSize="sm" color="micu.textSecondary" mb={2}>Case Name</Text>
      <Input
        ref={inputRef}
        variant="micu"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Enter case name"
        size="lg"
        mb={6}
        autoFocus
      />

      <Flex gap={3}>
        <Button
          variant="micuGhost"
          flex={1}
          onClick={() => navigate('/micu-mobile')}
        >
          Cancel
        </Button>
        <Button
          variant="micuPrimary"
          flex={1}
          onClick={handleCreate}
          isLoading={creating}
          isDisabled={!name.trim()}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default MICUNewCase;
